/* HSC out-of-stock sink — replaces the Nada app.
   Reorders sold-out product cards to the bottom of a collection grid.
   Defensive: only ever re-orders existing cards; never hides or removes.
   Re-runs after Ella's AJAX filter/sort/paginate swaps the grid. */
(function () {
  'use strict';
  var SORTING = false;

  function sink(grid) {
    if (!grid || SORTING) return;
    var nodes = Array.prototype.slice.call(grid.querySelectorAll('[data-grid-item]'));
    if (nodes.length < 2) return;

    // Only act if a sold-out card is followed by an available one (i.e. out of order).
    var seenSold = false, needs = false;
    for (var i = 0; i < nodes.length; i++) {
      var sold = nodes[i].getAttribute('data-available') === 'false';
      if (sold) { seenSold = true; }
      else if (seenSold) { needs = true; break; }
    }
    if (!needs) return;

    SORTING = true;
    try {
      nodes.forEach(function (n) {
        if (n.getAttribute('data-available') === 'false') grid.appendChild(n);
      });
    } catch (e) { /* fail safe */ }
    SORTING = false;
  }

  function run() {
    var grid = document.getElementById('CollectionLoop');
    if (grid) sink(grid);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Ella replaces #CollectionLoop on AJAX filter/sort — watch and re-run.
  try {
    var target = document.querySelector('[data-products-grid]');
    if (target && window.MutationObserver) {
      new MutationObserver(function () {
        if (SORTING) return;
        window.requestAnimationFrame(run);
      }).observe(target, { childList: true, subtree: true });
    }
  } catch (e) { /* no-op */ }
})();
